import { DateBox } from "devextreme-react";
import { DateType } from "devextreme/ui/date_box";
import { Controller, useFormContext, useFormState } from "react-hook-form";

interface IProps {
  title?: string;
  startTitle?: string;
  endTitle?: string;
  startDateFieldName: string;
  endDateFieldName: string;
  required?: boolean;
  showBorder?: boolean;
  dateType?: DateType;
  disabled?: boolean | undefined;
  defaultValue?: any;
}

export const NFLookupPeriod = ({
  title,
  startTitle,
  endTitle,
  startDateFieldName,
  endDateFieldName,
  required,
  dateType = "datetime",
  showBorder = true,
  disabled = false,
  defaultValue,
}: IProps) => {
  const { control } = useFormContext();
  const { errors, dirtyFields } = useFormState();

  return (
    <div className={title ? "form-group" : ""}>
      {title && <label className={"form-label-sm"}>{title}</label>}
      <div className="dx-date-box-parent mb-2">
        <div className="date-range-container d-flex justify-content-between">
          <Controller
            control={control}
            name={startDateFieldName}
            defaultValue={defaultValue}
            rules={{
              required: required === true,
              onChange: (newValue: string) => {},
            }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <div className="date-input-container d-flex align-items-end">
                {startTitle && <label className="me-2">{startTitle}</label>}
                <DateBox
                  type={dateType}
                  value={value}
                  onValueChanged={(e) => onChange(e.value)}
                  style={{ border: showBorder === true ? "block" : "none" }}
                  className="bg-light"
                  readOnly={disabled === true ? true : undefined}
                  validationStatus={
                    errors[startDateFieldName]
                      ? "invalid"
                      : dirtyFields[startDateFieldName]
                      ? "valid"
                      : "valid"
                  }
                />
              </div>
            )}
          />

          <Controller
            control={control}
            name={endDateFieldName}
            defaultValue={null}
            render={({ field: { onChange, value } }) => (
              <div className="date-input-container d-flex align-items-end">
                {endTitle && <label className="me-2">{endTitle}</label>}
                <DateBox
                  type={dateType}
                  value={value}
                  onValueChanged={(e) => onChange(e.value)}
                  style={{ border: showBorder === true ? "block" : "none" }}
                  className="bg-light"
                  readOnly={disabled === true ? true : undefined}
                />
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};
